export default "__VITE_ASSET__zHCdcwLP__"